import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BasicModalModel } from 'src/app/shared/models/basic-modal/BasicModalModel';
import {SafeHtml} from '@angular/platform-browser';
import {HtmlSanitizer} from '../../../services/html-sanitizer';

@Component({
selector: 'app-basic-confirm-modal',
  templateUrl: './basic-confirm-modal.component.html',
  styleUrls: ['./basic-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BasicConfirmModalComponent implements OnInit {
  public message: SafeHtml;

  constructor(
      @Inject(MAT_DIALOG_DATA) public readonly modalContent: BasicModalModel,
      private readonly dialogRef: MatDialogRef<BasicConfirmModalComponent>,
      private htmlSanitizer: HtmlSanitizer
  ) {
  }

  ngOnInit(): void {
    this.message = this.modalContent.message != null ? this.htmlSanitizer.safe(this.modalContent.message) : '';
  }

  onActionTaken(event: boolean){
    this.dialogRef.close(event);
  }
}
